import { Button, RefBool } from '@tblabs/truffle';
import { Svg } from '../Svg';
import { Icons } from '../../Icons';


export class SoundSwitch extends Button
{
    constructor(ref: RefBool)
    {
        super("");

        this.RemoveAllClasses().BorderNone().CursorPointer()

        this.OnClick(() => ref.Toggle());

        this.Append(
            new Svg(Icons.Volume22).Visible(ref),
            new Svg(Icons.VolumeX2).Invisible(ref)
        );
    }
}
